import { useEffect, useState } from "react";
import BookingForm from "../components/BookingForm";
import physic from "../assets/images/first.png";
import background from "../assets/images/Ubackground.png";
import BackHeader from "../components/Home/BackHeader";
import StepIndicator from "../components/Home/StepIndicator";
import HeroBanner from "../components/Home/HeroBanner";
import OfferHighlight from "../components/Home/OfferHighlight";
import GoogleRating from "../components/Home/GoogleRating";
import TestimonialCarousel from "../components/Home/TestimonialCarousel";
import CityModal from "../components/CityModal";
import { useNavigate, useParams } from "react-router-dom";
import { usePartner } from "../context/PartnerContext";


const Form = ({ isFreelanceFlow = false }) => {
  const [city, setCity] = useState("Mumbai");
  const [formData, setFormData] = useState({
    user_name: "",
    user_phone: "",
    pinCode: "",
    city: "Mumbai",
  });
  const navigate = useNavigate();
  const { partnerSlug } = useParams();
  const { config } = usePartner() || {};




  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (isFreelanceFlow) {
      sessionStorage.setItem("isFreelance", "true");
    } else {
      sessionStorage.removeItem("isFreelance");
    }
  }, [isFreelanceFlow]);


  useEffect(() => {
    const savedCity = localStorage.getItem("selectedCity");
    if (savedCity) {
      setCity(savedCity);
      setFormData((prev) => ({ ...prev, city: savedCity }));
    } else {
      setShowModal(true);
    }
  }, []);

  const handleCitySelect = (selectedCity) => {
    setCity(selectedCity);
    setFormData((prev) => ({ ...prev, city: selectedCity }));
    setShowModal(false);
  };

  const handleCityChangeFromForm = (newCity) => {
    setCity(newCity);
    setFormData((prev) => ({ ...prev, city: newCity }));
    localStorage.setItem("selectedCity", newCity);
  };

  const handleBackButtonClick = () => {
    setFormData({
      user_name: "",
      user_phone: "",
      city: "",
      pinCode: "",
    });
    window.location.href = "https://www.physica.fit";
  };

  return (
    <div className="relative min-h-screen w-full overflow-x-hidden bg-white">
      {showModal && <CityModal onSelect={handleCitySelect} />}

      <div className="relative z-10 flex flex-col justify-start items-center w-full mt-0 mb-0 md:mt-5 md:mb-10">
        <div className="w-full max-w-[700px] rounded-2xl shadow-lg bg-cover bg-no-repeat">
          <BackHeader onBack={handleBackButtonClick} />
          <StepIndicator step={1} totalSteps={4} header="Patient Details" />
          <img src={config?.background_url || physic} className="w-full rounded-2xl mt-3" alt="image not found" />
          <div
            className="w-full"
            style={{
              backgroundImage: `url(${background})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: '0 0 30px 30px',
            }}
          >
            <HeroBanner />
            <OfferHighlight selectedCity={city} />
            <BookingForm
              formTypeProp="form"
              prefilledCity={city}
              onCityChange={handleCityChangeFromForm}
            />
            <GoogleRating />
            <TestimonialCarousel />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
